<div class="official-website-home-page">
  <div class="header-title">
    <h1><span>BSS 博世配件优选店</span></h1>
    <!-- <p>BSS博世汽车零件严选店是与博世授权经销商一同合作，由博世授权经销商供货的博世汽车零件，为博世汽车零件的指定销售点之一。</p> -->
  </div>
  <div class="business-content">
    <div class="business-left">
      <img src="assets/official-website/BSS.jpg" class="w-full" alt="BSS">
    </div>
    <div class="business-right">
      <div class="bss-sub-header">
        <div>
          <h1 style="margin-bottom: unset;">BSS 博世配件优选店</h1>
          <h1>Bosch Selected Shop</h1>
        </div>
        <img class="auth-plate-img" src="assets/official-website/authorization-plate.png" class="w-full" alt="BSS">
      </div>
      <p style="margin-bottom: unset;">
        ​是由博世发起，与优选经销商及战略合作伙伴共同发展的会员优选店，通过为修理厂提供​品牌认证及形象提升，产品支持及售后保障，技能培训及增值服务，数字化赋能提效，​融合博世配件、诊断及维修站服务，持续提升会员优选店的满意度，为所有关联方创造价值。
      </p>
      <p style="margin-bottom: unset;">加盟咨询热线：400-000-5109</p>
      <p>服务时间：工作日9:00-18:00（节假日除外）</p>
    </div>
  </div>
</div>